import { Brain } from 'lucide-react';

import CollapsibleBlock from '../CollapsibleBlock';

function sigSize(signature: string): string {
  return signature.length > 1000
    ? `${(signature.length / 1024).toFixed(1)}KB`
    : `${signature.length} chars`;
}

export default function ThoughtsField({
  signature,
  thoughts,
}: {
  signature?: string;
  thoughts: string[];
}) {
  const firstThought = thoughts[0]?.replace(/\s+/g, ' ').trim() ?? '';
  const summary = firstThought
    ? firstThought.slice(0, 80)
    : signature
      ? `signature · ${sigSize(signature)}`
      : '';

  return (
    <CollapsibleBlock
      icon={<Brain className="h-3.5 w-3.5" />}
      label="Thoughts"
      summary={summary}
      tone="amber"
    >
      {signature && (
        <div className="mb-2">
          <div className="mb-1 text-[11px] font-medium text-muted-foreground/70">
            signature · {sigSize(signature)}
          </div>
          <div className="max-h-32 overflow-y-auto break-all font-mono text-[11px] text-muted-foreground/70">
            {signature}
          </div>
        </div>
      )}
      {thoughts.map((thought, i) => (
        <div
          key={i}
          className="whitespace-pre-wrap text-sm text-muted-foreground"
        >
          {thought}
        </div>
      ))}
    </CollapsibleBlock>
  );
}
